<template>
  <div class="img-item" :style="{ width, height }">
    <img v-if="loading" class="loading" src="../assets/images/loading.svg" />
    <template v-if="value !== ''">
      <img v-if="video" ref='firstV' v-lazy='value'/>
      <img v-else v-lazy="`${value}?x-oss-process=image/resize,fill,w_196,h_196`" />
      <img @click="playVideo" v-if="video" src="../assets/images/dynamic/playBtn.png" class="play-img" />
      <img @click="removeImg" src="../assets/images/removeImg.svg" class="remove-img" />
    </template>
    <template v-else>
      <slot name="content">
        <span class="img-row"/>
        <span class="img-column"/>
      </slot>
      <input  class="uploadFile" accept="image/*" :style="{ width: inputWidth ? inputWidth : width , height }" @change="uploadFile" type="file"/>
    </template>
  </div>
</template>
<script>
import { putFile } from '../utils/request.js'
import { compressImage } from '../utils/utils'
import { Toast } from 'vant'
export default {
  props: {
    video: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '98px'
    },
    inputWidth: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '98px'
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    playVideo () {
      Toast.fail('暂不支持预览')
    },
    removeImg () {
      this.$emit('removeImg')
    },
    async uploadFile (e) {
      if (e.target.files[0].type.split('/')[0] === 'video') {
        Toast.fail('视频只能单独发布')
        return
      }
      const imgFile = await compressImage(e.target.files[0], 0.8)
      this.$emit('uploadStart')
      this.loading = true
      const promise = putFile({
        url: '/bbs/uploadFile',
        file: imgFile
      })
      promise.then(res => {
        const { status, data: { detail: data } } = res
        let url = ''
        if (Object.is(status, 200)) {
          url = data[0]
          if (url.indexOf('https') === -1) {
            url = url.replace('http', 'https')
          }
        }
        if (Object.is(status, 205)) {
          Toast.fail('图片违规！')
        }
        this.$emit('input', url)
        this.$emit('uploadSuccess')
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes roate{
  from {
     transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.img-item {
  display: inline-block;
  // margin-right: 1.33vw;
  background: #f5f5f5;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .loading {
          width: 40px !important;
          height: 40px !important;
          z-index: 99;
          position: absolute;
          top: calc(50% - 20px);
          left: calc(50% - 20px);
          animation: roate 0.5s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
        }
  .play-img {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -16px;
    margin-top: -16px;
    width: 32px;
    height: 32px;
  }
  .remove-img {
    position: absolute;
    right: 0;
    top: 0;
    width: 32px;
    height: 32px;
  }
  .img-row,
  .img-column {
    background: rgba(172, 172, 172, 1);
    position: absolute;
  }
  .img-row {
    width: 32px;
    height: 2px;
    top: calc(50% - 1px);
    left: calc(50% - 16px);
  }
  .img-column {
    height: 32px;
    width: 2px;
    top: calc(50% - 16px);
    left: calc(50% - 1px);
  }
  .uploadFile {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 26.13vw;
    height: 26.13vw;
    outline: none;
    opacity: 0;
  }
}
</style>
